import React from 'react';
import { Base } from '@stepstone-genesis/system';
import { DocumentDocIcon } from '@stepstone-genesis/icons';
import { Paragraph } from '@stepstone-genesis/components-paragraph';
import { LinearProgressBar } from '@stepstone-genesis/components-progress-linear-bar';
import { Flex } from '@stepstone-genesis/components-flex';
import { getLabel } from '../../utils/helpers/labelsService';
import { MODAL_DATA_AT } from '../consts';
export var UploadProgressBar = function (_a) {
    var fileName = _a.fileName, value = _a.value;
    var uploadLabel = getLabel('progressBar.uploading');
    return (React.createElement(Base, { sx: { padding: 'spaceNone', width: '100%' }, "data-at": "".concat(MODAL_DATA_AT, "-progress-bar") },
        React.createElement(Flex, { flxDirection: "row", pb: 'spaceS', sx: {
                alignItems: 'center',
                justifyContent: 'center',
                flexWrap: 'nowrap',
            } },
            React.createElement(DocumentDocIcon, { mr: 'spaceM', size: "xxl", sx: { color: 'colorGreyDark', flexShrink: 0 } }),
            React.createElement(Flex, { flxDirection: "column", flxShrink: 1 },
                React.createElement(Paragraph, { sx: { textAlign: 'start' }, truncate: true }, fileName),
                React.createElement(Paragraph, { sx: { textAlign: 'start' }, color: "colorStatusDefault" }, uploadLabel))),
        React.createElement(LinearProgressBar, { value: value })));
};
//# sourceMappingURL=index.js.map